<template>
  <div class="intelligentAgriculture-page">
    <!-- 乡村资源一张图 -->
    <div class="haeder-container blackStatic" style="height:141px;">
      <Header></Header>
      <Nav></Nav>
    </div>
    	<div class="main text-img-box">
			<div class="top-banner">            
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/greenhouse/index.png">            
            </div>		
            <div class="mid-swiper">
                <i class="left-line2"></i>
                <p>百倍云智慧大棚建设方案</p>
                <i class="right-line2"></i>
                      <div class="greenhouse-swiper-container">
                        <swiper class="swiper" :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
                        <!-- slides -->
                        <swiper-slide class="swiper-item">
                            <div class="swiper-item-container">
                                <div class="swiper-item-content-container1">
                                    <div class="greenhouse-top-header">
                                        <span>01</span>
                                        <p>玻璃温室</p>
                                        <font>选材优良/结构稳定</font>
                                    </div>
                                    <p class="greenhouse-top-text">玻璃温室外观现代、新颖，结构稳定，视觉流畅，透光率极强，可高达90%以上，抗风雪能力强。覆盖材料为国产单层浮法玻璃或双层中空玻璃使用寿命长，光照均匀、强度比较高，具有极强的防腐性、阻燃性。90%以上的透光，且不随时间衰退等优点。</p>
                                </div>
                                <div class="greenhouse-additional">
                                    <a class="left-arr" @click="slideTo( 3 )"><img src="../../assets/img/caseDetails/greenhouse/leftarrow.png" alt=""></a>
                                    <a class="right-arr" @click="slideTo( 2 )"><img src="../../assets/img/caseDetails/greenhouse/rightarrow.png" alt=""></a>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="swiper-item">
                            <div class="swiper-item-container">
                                <div class="swiper-item-content-container2">
                                    <div class="greenhouse-top-header">
                                        <span>02</span>
                                        <p>薄膜温室</p>
                                        <font>选材优良/结构稳定</font>
                                    </div>
                                    <p class="greenhouse-top-text"> 制造成本相对较低，属经济型温室，适用于我国大部分地区。北方地区多采用双层膜温室，南方地区多选用单膜温室。能在可见光0.4-0.7微米范围内得到最大光照，层膜充气后，可以形成厚厚的气囊，能有效地防止热量流失和阻止冷空气的侵入。</p>                                                                 
                                </div>
                                <div class="greenhouse-additional">
                                    <a class="left-arr" @click="slideTo( 1 )"><img src="../../assets/img/caseDetails/greenhouse/leftarrow.png" alt=""></a>
                                    <a class="right-arr" @click="slideTo( 3 )"><img src="../../assets/img/caseDetails/greenhouse/rightarrow.png" alt=""></a>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="swiper-item">
                            <div class="swiper-item-container">
                                <div class="swiper-item-content-container3">
                                    <div class="greenhouse-top-header">
                                        <span>03</span>
                                        <p>阳光板温室</p>
                                        <font>选材优良/结构稳定</font>
                                        </div>
                                        <p class="greenhouse-top-text"> （PC板）与其它覆盖材料相比，具有采光好、保暖、轻便、强度高、防结露、抗冲击PC板材料只融化不扩展，在极高温度下，有良好的阻燃性、经济耐用、安装使用过程中不会断裂或破碎，极强的适应性和安全性等诸多优点。</p>                                                                 
                                
                                    
                                </div>
                                <div class="greenhouse-additional">
                                    <a class="left-arr" @click="slideTo( 2 )"><img src="../../assets/img/caseDetails/greenhouse/leftarrow.png" alt=""></a>
                                    <a class="right-arr" @click="slideTo( 1 )"><img src="../../assets/img/caseDetails/greenhouse/rightarrow.png" alt=""></a>
                                </div>
                            </div>
                        </swiper-slide>
                        <!-- Optional controls -->
                        <div class="swiper-pagination"  slot="pagination"></div>
                        </swiper>
                    </div>


            </div>
            <div class="greenhose-box">
                <div class="greenhose-box-nav">
                    <p>大棚建设内容</p>
                    <ul>
                        <li  :class="[ active==item.id ? 'nav-light greenhose-nav' : 'greenhose-nav']"   v-for="( item , key ) in navdata" :key="key" @click="change(item)">{{item.title}}</li>
                    </ul>
                </div>

                 <div class="greenhose-box-class">
                    <p>{{title}}</p>
                    <div class="greenhose-img-box" v-for="( item , key ) in navimg" :key="key" v-if="key == active">
                        <img style="width:75%;height:auto" :src="item.url" v-if="key == 3"> 
                        <img style="width:100%;height:auto" :src="item.url" v-else>       
                    </div>

                </div>   
            </div>
             <div class="mid-swiper2">
                <i class="left-line2"></i>
                <p>温室大棚智能化建设</p>
                <i class="right-line2"></i>
                <img style="width:824px;height:auto;margin:auto" src="../../assets/img/caseDetails/greenhouse/index2.png">            
            </div>
            <!-- 模块1 -->
			<div class="maim-module-03">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-text">
						<h2 style="text-align: left;">环境数据采集</h2>
						<div class="segmentation" style="text-align: left;">
							<img src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							智能硬件数据采集作为关键一环,为智慧农业大棚的智能控制和农业专家分析提供数据支撑服务。利用无线技术实现智能硬件智能联动、自动组网,并对环境数据实时远程监控。
						</div>
					</div>
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/greenhouse/img1.png" class="img-model">
					</div>
				</div>
			</div>
			<!-- 模块2 -->
			<div class="maim-module-02">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/greenhouse/img2.png" class="img-model">
					</div>
					<div class="maim-module-02-center-text">
						<h2>智能控制</h2>
						<div class="segmentation">
							<img style="float:right;" src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							当传感器采集的环境数据超出设定值时,控制器自动(或远程手动)启动相关硬件设备对作物生长环境加热、施肥浇水、通风、卷帘加减光照辐射, 实现作物生长过程智能化精确控制。
						</div>
					</div>
				</div>
			</div>
			<!-- 模块3 -->
			<div class="maim-module-03">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-text">
						<h2 style="text-align: left;">水肥一体机联动系统</h2>
						<div class="segmentation" style="text-align: left;">
							<img src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							组合土壤传感器和水肥一体化状态，通过规则引擎智能分析，管理温室内各个区域水肥精准浇水和施肥，从而实现环境的智能调控。
						</div>
					</div>
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/greenhouse/img3.png" class="img-model">
					</div>
				</div>
			</div>
			<!-- 模块4 -->
			<div class="maim-module-02">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/greenhouse/img4.png" class="img-model">
					</div>
					<div class="maim-module-02-center-text">
						<h2>无线视频监控管理</h2>
						<div class="segmentation">
							<img style="float:right;" src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							大棚监控室通过“无线视频监控管理云平台”实现远程监控、视频采集、录像回放和智能运维,并为智能硬件数据传输提供服务。
						</div>
					</div>
				</div>
			</div>
			<!-- 模块5 -->
			<div class="maim-module-03">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-text">
						<h2 style="text-align: left;">智能预警</h2>
						<div class="segmentation" style="text-align: left;">
							<img src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							基于于大数据技术,通过数据建模预警分析,当大棚环境数据达到标准值时,系统向专家、监控中心和手机客户端发出报警信息。如是自动启动设备,系统也会发给通告信息。
						</div>
					</div>
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/greenhouse/img5.png" class="img-model">
					</div>
				</div>
			</div>
            <!-- 模块6 -->
			<div class="maim-module-02">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/greenhouse/img6.png" class="img-model">
					</div>
					<div class="maim-module-02-center-text">
						<h2>食品安全溯源</h2>
						<div class="segmentation">
							<img style="float:right;" src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							大棚监控室通过“无线视频监控管理云平台”实现远程监控、视频采集、录像回放和智能运维,并为智能硬件数据传输提供服务。
						</div>
					</div>
				</div>
			</div>
            <!-- 模块7 -->
			<div class="maim-module-03">
				<div class="maim-module-02-center">
					<div class="maim-module-02-center-text">
						<h2 style="text-align: left;">集中监控管理端</h2>
						<div class="segmentation" style="text-align: left;">
							<img src="../../assets/img/caseDetails/intelligentAgricultureall/index01-02.png">
						</div>
						<div class="text02">
							实现温室环境实时监控、远程智能控制、视频监控、设备运行状态自动监控、智能报警等，大大提高管理效率。
						</div>
					</div>
					<div class="maim-module-02-center-img">
						<img src="../../assets/img/caseDetails/greenhouse/img7.png" class="img-model">
					</div>
				</div>
			</div>
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {
        swiperOption: {
            // some swiper options/callbacks
            // 所有的参数同 swiper 官方 api 参数
            loop : true,
            initialSlide: 0, // 默认显示第几个
            autoplay: {
            delay: 2000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
            },
            pagination: {
            el: '.swiper-pagination',
            bulletElement : 'li',
            bulletClass : 'my-bullet',//需设置.my-bullet样式
            bulletActiveClass: 'my-bullet-active',
            clickable :true,
            
            },
        },
        title:"温室基础建设",
        navdata:[
            {
                title:"温室基础建设",
                id:0,
            },{
                title:"温室主体骨架",
                id:1,
            },{
                title:"覆盖材料",
                id:2,
            },{
                title:"通风系统",
                id:3,
            },{
                title:"内遮阳系统",
                id:4,
            },{
                title:"水帘侧窗系统",
                id:5,
            },{
                title:"风机湿帘降温系统",
                id:6,
            },{
                title:"雨水排水系统",
                id:7,
            },{
                title:"配电及电动控制系统",
                id:8,
            },{
                title:"供暖内保温系统",
                id:9,
            },{
                title:"供暖内保湿系统",
                id:10,
            }
        ],
        navimg:[
           {
               url:require('../../assets/img/caseDetails/greenhouse/nav1.png'),
           },{
               url:require('../../assets/img/caseDetails/greenhouse/nav2.png'),
           },{
               url:require('../../assets/img/caseDetails/greenhouse/nav3.png'),
           },{
               url:require('../../assets/img/caseDetails/greenhouse/nav4.png'),
           },{
               url:require('../../assets/img/caseDetails/greenhouse/nav5.png'),
           },{
               url:require('../../assets/img/caseDetails/greenhouse/nav6.png'),
           },{
               url:require('../../assets/img/caseDetails/greenhouse/nav7.png'),
           },{
               url:require('../../assets/img/caseDetails/greenhouse/nav8.png'),
           },{
               url:require('../../assets/img/caseDetails/greenhouse/nav9.png'),
           },{
               url:require('../../assets/img/caseDetails/greenhouse/nav10.png'),
           },{
               url:require('../../assets/img/caseDetails/greenhouse/nav11.png'),
           },
        ],
        active:0,
    }
  },
  mounted() {
  },
    computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    change(e){
        this.title = e.title
        this.active = e.id
    },
    slideTo( index ){
      this.swiper.slideTo( index, 500, false) // 控制Swiper切换到指定slide。
    },
  }
}
</script>
<style>
 .haeder-container {
	width: 100%;
	height: 129px;
	margin: 0 auto;
	background-color: #030512;
}

div:after,
li:after,
ul:after {
	clear: both;
	content: "";
	width: 0;
	height: 0;
	display: block;
	visibility: hidden;
}

*{
    margin:0;
    padding:0;
}
html, body, div, span, object, iframe,h1, h2, 
h3, h4, h5, h6, p, blockquote, pre,abbr, address, cite, code,del, dfn, 
em, img, ins,kbd, q, samp,small, strong, sub, sup, var,b, i,dl, dt, dd, 
ol, ul, li,fieldset, form, label, legend,table, caption, tbody, 
tfoot,thead,tr, th, td,article, aside, canvas, details, figcaption, 
figure, footer, header, hgroup, menu, nav, section, summary,time, mark, 
audio, video {
    margin:0;
    padding:0;
    border:0;
    outline:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    outline-style:none;
}
 
body {
    line-height:1;
}
ol, ul{
    text-decoration: none;
    list-style: none;
}
a{
    margin:0;
    padding:0;
    border:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    text-decoration:none;
    outline-style:none;
}
a:hover,a:focus{
    text-decoration:none;
    outline-style:none;
    }
table {
    border-collapse:collapse;
    border-spacing:0;
}
input, select {
    vertical-align:middle;
}
.clear{
    clear: both;
}








@media all and (max-width: 1400px) and (min-width: 820px) {
	.main-bunner-img2 {
		width: 100%;
		height: 600px !important;
		background-image: url(~@/assets/img/caseDetails/village_resources/index.png);
		background-repeat: no-repeat;
		background-size: contain;
	}
}
.main-bunner-img2 {
	width: 100%;
	height: 800px;
	background-image: url(~@/assets/img/caseDetails/village_resources/index.png);
	background-repeat: no-repeat;
	background-size: contain;
}

.maim-module-01 {
	width: 100%;
	height: 700px;
	background: rgba(255, 255, 255, 1);
	display: flex;
	align-items: center;
}

.maim-module-01-center {
	width: 1200px;
	margin: 0 auto;
}

.maim-module-01-center-text {
	width: 1200px;
	height: 180px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	line-height: 36px;
}

.maim-module-02 {
	width: 100%;
	height: 700px;
	/* background: #FCF9FC; */
	display: flex;
	align-items: center;
}

.maim-module-02-center {
	width: 1200px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
}

.maim-module-02-center-img {
	width: 670px;
	height: 377px;
}

.maim-module-02-center-text {
	width: 460px;
	height: 377px;
	display: flex;
	flex-direction: column;

}

.text-img-box h2 {
	width: 460px;
	height: 45px;
	text-align: right;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: rgba(48, 181, 94, 1);
	line-height: 45px;
	margin-top: 25px;
	margin-bottom: 15px;
}

.segmentation {
	width: 460px;
	height: 5px;
	text-align: right;
	margin-top: 5px;
	margin-bottom: 20px;
}

.text02 {
	width: 460px;
	height: 216px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
  line-height: 36px;
  text-align: left;
}

.maim-module-03 {
	width: 100%;
	height: 700px;
	background: #FFFEFF;
	display: flex;
	align-items: center;
}

.img-model {
	width: 670px;
	height: auto;
}

.bottom {
	width: 100%;
	height: 1114px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/bj.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.bottom-center {
	width: 1040px;
	margin: 0 auto;
}

h3 {
	width: 1040px;
	height: 45px;
	text-align: center;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: rgba(51, 51, 51, 1);
	line-height: 45px;
	padding-top: 63px;
}

.separation-text {
	margin-top: 25px;
	display: flex;
	justify-content: center;
}

.separation-text-01 {
	width: 127px;
	height: 2px;
	text-align: center;
	background: rgba(51, 51, 51, 1);
	opacity: 0.49770000000000003;
}

.list {
	margin-top: 44px;
  text-align: left;
}

.list-text {
	display: inline-block;
	width: 848px;
	height: 36px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	line-height: 36px;
  margin-left: 20px;
}

.mid-swiper{
    background-image: url(~@/assets/img/caseDetails/greenhouse/bg.png);
    width: 100%;
    height: 600px;
    background-size: contain;
    position: relative;
    padding-top: 60px;
}
.mid-swiper p{
    color: #579B2D;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 60px;
}   

.mid-swiper .left-line2{
    position: absolute;
    left: 50%;
    width: 60px;
    height: 1px;
    background: #C7C7C7;
    margin-left: 140px;
    top: 70px;
}

.mid-swiper .right-line2{
    position: absolute;
    right: 50%;
    width: 60px;
    height: 1px;
    background: #C7C7C7;
    margin-right: 140px;
    top: 70px;
}

.mid-swiper2{
    width: 100%;
    height: 640px;
    background-size: contain;
    position: relative;
    padding-top: 60px;
}
.mid-swiper2 p{
    color: #579B2D;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 40px;
}   

.mid-swiper2 .left-line2{
    position: absolute;
    left: 50%;
    width: 60px;
    height: 1px;
    background: #C7C7C7;
    margin-left: 140px;
    top: 70px;
}

.mid-swiper2 .right-line2{
    position: absolute;
    right: 50%;
    width: 60px;
    height: 1px;
    background: #C7C7C7;
    margin-right: 140px;
    top: 70px;
}

.greenhose-box{
    height: 843px;
    width: 1200px;
    margin: auto;
    padding: 80px 0;
    box-sizing: border-box;
    margin-bottom: 20px;
}
.greenhose-box-nav{
    float: left;
    height: 663px;
    width: 300px;
    margin-right: 20px;
    border: 1px solid #eee;
    box-sizing: border-box;
}
.greenhose-box-nav p{
    text-align: center;
    background: #579B2D;
    font-weight: 700;
    font-size: 20px;
    color: #fff;
    padding: 20px 0;
}
.greenhose-nav{
    text-align: center;
    background: #fff;
    font-weight: 500;
    font-size: 14px;
    color: #333;
    padding: 20px 0;
    border-bottom: 1px solid #eee;
    cursor: pointer;
}
.greenhose-box-class{
    float: left;
    height: 580px;
    width: 880px;
}
.greenhose-box-class p{
    text-align: right;
    background: linear-gradient(0deg, #F0F0F0 0%, #FFFFFF 100%);
    font-weight: 500;
    font-size: 18px;
    color: #666;
    line-height: 40px;
    padding: 10px 20px;
    box-sizing: border-box;
}
.greenhose-img-box{
    height: 658px;
    width: 100%;
    margin-right: 20px;
    border: 1px solid #eee;
    box-sizing: border-box;
    padding: 15px;
}

.nav-light{
    background: #F76E28 !important;
    color: #fff !important;
}

.greenhouse-swiper-container{
    width: 1200px;
    margin: auto;
}

.swiper-item-content-container1{
    background: url('~@/assets/img/caseDetails/greenhouse/swiper1.png') no-repeat center center;
    background-size: cover;
    height: 380px;
}
.swiper-item-content-container2{
    background: url('~@/assets/img/caseDetails/greenhouse/swiper2.png') no-repeat center center;
    background-size: cover;
    height: 380px;
}
.swiper-item-content-container3{
    background: url('~@/assets/img/caseDetails/greenhouse/swiper3.png') no-repeat center center;
    background-size: cover;
    height: 380px;
}

.greenhouse-additional{
    position: absolute;
    top: 303PX;
    right: 436px;
    width: 120px;
}

.left-arr{
    float: left;
    border-top: 42px solid #F76E28;
    border-left: 0px solid transparent;
    border-right: 20px solid transparent;
    height: 0;
    width: 60px;
}
.left-arr img{
    position: absolute;
    top: 13px;
    left: 17px;
    width: 16px;
}

.right-arr{
    float: right;
    width: 60px;
    height: 41px;
}

.right-arr img{
    position: absolute;
    top: 13px;
    right: 34px;
    width: 16px;
}
.greenhouse-top-header{
    position: absolute;
    top: 40px;
    right: 85px;
    width: 220px;
}
.greenhouse-top-header span{
    background: url('~@/assets/img/caseDetails/greenhouse/jx.png') no-repeat center center;
    width: 90px;
    height: 90px;
    text-align: center;
    line-height: 90px;
    color: #589A1C;
    font-size: 36px;
    font-weight: 700;
    float: left;
}

.greenhouse-top-header p{
    margin-bottom: 7px;
    margin-top: 20px;
    letter-spacing: 1px;
    color: #fff;
}

.greenhouse-top-header font{
    font-size: 12px;
    color: #fff;
}
.greenhouse-top-text{
    border: 1px solid #fff;
    color: #fff !important;
    position: absolute;
    right: 36px;
    top: 144px;
    width: 305px;
    font-size: 12px !important;
    line-height: 24px;
    font-weight: 500 !important;
    text-align: justify;
    padding: 10px;
    border-radius: 4px;

}
</style>